/**
 * @file ExperienceDetailsPage.tsx
 * @path apps/website/src/pages/ExperienceDetailsPage.tsx
 */

import { Navigate } from "react-router-dom";
import { DetailsLayout } from "@/components/layouts/details.layout";
import {
  ContentSection,
  ExperienceDetailsHero,
  SidebarSection,
  useExperienceDetail,
} from "@/features";

export const ExperienceDetailsPage = () => {
  const { data, isNotFound } = useExperienceDetail();

  if (isNotFound) return <Navigate to="/experiences" replace />;
  if (!data) return null;

  return (
    <DetailsLayout bookingLink={data.bookingLink}>
      <ExperienceDetailsHero data={data} />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-start">
        <ContentSection data={data} />
        <SidebarSection data={data} />
      </div>
    </DetailsLayout>
  );
};
